import React, { FunctionComponent, useLayoutEffect, useRef, useState } from "react"
import { springDelay } from "./utils/animationUtils"

const pipWidth = 8

const Pip = ({ active, delay }: { active: boolean; delay: number }) => (
    <div className="relative h-7 bg-gray-700 rounded-[3px]" style={{ width: `${pipWidth}px` }}>
        {active && (
            <div
                className="absolute inset-0 bg-seafoam rounded-[3px] motion-safe:animate-pip-fill"
                style={{ animationDelay: `${delay}ms` }}
            />
        )}
    </div>
)

interface PipChartProps {
    percentage: number // 0 to 1
}

export const PipChart: FunctionComponent<PipChartProps> = ({ percentage }) => {
    const containerRef = useRef<HTMLDivElement>(null)
    const [numPips, setNumPips] = useState(0)

    useLayoutEffect(() => {
        if (!containerRef.current) return

        const update = (el: Element) => {
            const width = el.getBoundingClientRect().width
            const count = Math.floor((width + 3) / (pipWidth + 3))
            setNumPips(count)
        }

        update(containerRef.current)
        const observer = new ResizeObserver(([entry]) => update(entry.target))
        observer.observe(containerRef.current)
        return () => observer.disconnect()
    }, [])

    const activeLimit = Math.round(percentage * numPips)

    return (
        <div className="w-full flex gap-[3px] flex-wrap overflow-hidden h-7" ref={containerRef}>
            {[...Array(numPips)].map((_, i) => (
                <Pip
                    key={`${i}-${i < activeLimit}`}
                    active={i < activeLimit}
                    delay={springDelay(i / activeLimit, 600)}
                />
            ))}
        </div>
    )
}
